import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundPageComponent } from './page-not-found-page.component';
@NgModule({
  declarations: [PageNotFoundPageComponent],
  imports: [
    CommonModule
  ]
})
export class PageNotFoundPageModule { }
